module.exports = __webpack_public_path__ + "images/patterns/dark/BrickDiagonal.b89394af8c9a0277ce97.svg";